import { render, staticRenderFns } from "./EditIssuePopup.vue?vue&type=template&id=ec73f888&scoped=true"
import script from "./EditIssuePopup.vue?vue&type=script&lang=js"
export * from "./EditIssuePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec73f888",
  null
  
)

export default component.exports